import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import DOMPurify from 'dompurify';
import VueMarkdown from 'vue-markdown';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportSummary',
  props: {
    title: null,
    tags: null,
    content: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  tags?: string[];
  content?: string | null;
};



// Treat content as HTML only when it starts with a real HTML tag.
// A loose check like /<[^>]+>/ misbehaves on markdown that mentions XML/HTML
// tags in text (e.g. Android manifest snippets like <activity>), sending the
// whole string down the v-html branch and leaving markdown syntax unrendered.
const HTML_CONTENT_START_REGEX = /^\s*<\/?[a-zA-Z][a-zA-Z0-9]*(\s[^>]*)?\/?>/;
const isHtmlContent = computed(
  () => !!props.content && HTML_CONTENT_START_REGEX.test(props.content)
);

const sanitizedHtmlContent = computed(() =>
  isHtmlContent.value && props.content ? DOMPurify.sanitize(props.content) : ''
);

return { __sfc: true,props, HTML_CONTENT_START_REGEX, isHtmlContent, sanitizedHtmlContent, VueMarkdown }
}

})